<script>
export default {
  props: {
    name: String,
    value: [String, Number]
  },
  data() {
    return {
      wasCopied: false,
      timer: null
    }
  },
  methods: {
    switchIcon() {
      this.wasCopied = true

      this.timer = setTimeout(() => {
        this.wasCopied = false
      }, 1500)
    },
    resetIcon() {
      this.wasCopied = false
      clearTimeout(this.timer)
    }
  }
}
</script>

<template>
  <button
    class="metadata-container"
    v-clipboard="value"
    v-clipboard:success="switchIcon"
    @mouseleave="resetIcon"
    title="Copy to clipboard"
  >
    <p class="metadata-text" v-test="{ metadata: name }">
      <b>{{ name }}</b> <span>{{ value }}</span>
    </p>
    <svg class="metadata-icon icon icon--lg">
      <use xlink:href="#check" v-if="wasCopied"></use>
      <use xlink:href="#clippy" v-else></use>
    </svg>
  </button>
</template>

<style lang="scss">
@import '@/styles/_functions.scss';
@import '@/styles/_settings.scss';

.metadata-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-width: 20em;

  background: none;
  padding: 5px 10px;
  border: 0;
  text-align: left;
  font-size: $font-size-sm;
  text-decoration: none;

  &:hover {
    background: $gray-200;

    .metadata-icon {
      opacity: 1;
    }
  }
}

.metadata-text {
  flex: 1 1 auto;
  margin-right: 10px;

  b {
    display: block;
    font-size: $font-size-xxs;
    text-transform: uppercase;
    color: $gray-600;
  }
}

.metadata-icon {
  flex: 0 1 auto;
  opacity: 0;
  color: $gray-600;
}
</style>
